import { atom } from 'jotai';

import type { FTOErrorModalParams } from '../../models';

type FanTokenOfferingAPIErrorModalAtom = { data: FTOErrorModalParams; visible: true } | { visible: false };

export const fanTokenOfferingAPIErrorModalAtom = atom<FanTokenOfferingAPIErrorModalAtom>({
	visible: false
});
